module.exports = __webpack_public_path__ + "img/android-tv-icon.84fe6100.svg";